import { render } from "./CreditoSimplePF.vue?vue&type=template&id=c48ff4a8"
import script from "./CreditoSimplePF.vue?vue&type=script&lang=js"
export * from "./CreditoSimplePF.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__